import { readFromCache } from './cache';
import { isEmptyObject } from './isEmptyObject';

export const getPropertyByKey = (key = '') => {
    const property = readFromCache('property') || {};

    if (isEmptyObject(property)) {
        return '';
    }

    return property[key];
};

export const getOpeningDataByKey = (key = '') => {
    const opening = readFromCache('opening') || {};

    if (isEmptyObject(opening)) {
        return '';
    }

    return opening[key];
};

export const getStaffProfile = (key = '') => {
    const staff = readFromCache('staff') || {};

    if (isEmptyObject(staff)) {
        return '';
    }

    return staff[key];
};
